/** Chromium console-message stringify loses non-enumerable native error fields. */
export function errorDetails(error: unknown): string {
  if (error && typeof error === "object") {
    const detail = error as { name?: string; message?: string; stack?: string; source?: string; streamErrorCode?: number };
    if (typeof detail.message === "string") {
      const summary = `${detail.name || "Error"}: ${detail.message}`;
      const transport = detail.source ? ` (source=${detail.source}, streamErrorCode=${detail.streamErrorCode ?? "null"})` : "";
      return `${summary}${transport}${detail.stack ? `\n${detail.stack}` : ""}`;
    }
  }
  return String(error);
}
